import Base from './base';

class View extends Base {
	constructor(...args) {
		super();
		this.el = typeof(args[0])==='string' ? this.makeElement(...arguments) : args[0];
	}

	query(query) {
		return Array.from(this.el.querySelectorAll(query));
	}

	addListener(type, match, method) {
		
		let elem = this.el;
		let callback = method;
		let matchSelector = match;

		if(typeof(match) === 'function') {
			callback = match;
			matchSelector = null;
		} else if(match === document || match == window ) {
			elem = match;
			matchSelector = null;
		} else if (match === 'body') {
			elem = document.body;
			matchSelector = null;
		} else if (match instanceof Element) {
			elem = match;
			matchSelector = null;
		}

		const eventListener = e => {
			if (!matchSelector) {
				return callback.call(this, e, this.el);
			}
			const elements = this.query(matchSelector);
			const element = elements.find( item => item.contains(e.target));
			if (element) {
				return callback.call(this, e, element);
			}
		};

		elem.addEventListener(type, eventListener);			
	}

	remove() {
		this.el.parentNode.removeChild(this.el);
	}
}

export default View;
